"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var _Search = _interopRequireDefault(require("@paprika/icon/lib/Search"));

var _useListBox3 = _interopRequireDefault(require("../../useListBox"));

var _PropsProvider = require("../../store/PropsProvider");

var _helpers = require("./helpers");

var sc = _interopRequireWildcard(require("./Filter.styles"));

var _excluded = ["renderFilter", "placeholder", "value", "onChangeFilter", "filter", "hasSearchIcon", "noResultsMessage"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function hasNoResults(textSearchValue, filteredOptions) {
  return textSearchValue && filteredOptions && filteredOptions.length === 0;
}

var Filter = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var I18n = (0, _useI18n["default"])();

  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 2),
      state = _useListBox2[0],
      dispatch = _useListBox2[1];

  var isOpen = state.isOpen,
      refFilterInput = state.refFilterInput;

  var _React$useContext = _react["default"].useContext(_PropsProvider.PropsContext),
      isDisabled = _React$useContext.isDisabled,
      isInline = _React$useContext.isInline,
      size = _React$useContext.size;

  var _React$useState = _react["default"].useState(props.value),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      textSearch = _React$useState2[0],
      setTextSearch = _React$useState2[1];

  var applyFilterType = _useListBox3["default"].types.applyFilter;

  _react["default"].useImperativeHandle(ref, function () {
    return {
      clear: function clear() {
        setTextSearch(function () {
          return "";
        });
      },
      reset: function reset() {
        (0, _helpers.applyFilter)(dispatch, applyFilterType)([], false);
        setTextSearch("");
      },
      focus: function focus() {
        refFilterInput.current.focus();
      },
      textSearch: textSearch
    };
  });

  var handleChangeFilter = function handleChangeFilter(event) {
    if (isDisabled) return;
    var textSearchValue = event ? event.target.value : "";

    if (props.filter) {
      setTextSearch(textSearchValue); // eventually we should get rid of this and just call props.filter as a callback without expecting to return anything

      var result = props.filter({
        search: textSearchValue
      });

      if (result && result.then) {
        // detecting if it's a promise
        result.then(function (response) {
          var filteredOptions = response;
          var noResultsFound = hasNoResults(textSearchValue, filteredOptions);
          (0, _helpers.applyFilter)(dispatch, applyFilterType)(filteredOptions, noResultsFound);
        });
      }

      return;
    }

    if (props.onChangeFilter) {
      props.onChangeFilter(event);
    } else {
      setTextSearch(textSearchValue);
    }

    var filteredOptions = (0, _helpers.filter)({
      props: props,
      state: state,
      textSearchValue: textSearchValue
    });
    var noResultsFound = hasNoResults(textSearchValue, filteredOptions);
    (0, _helpers.applyFilter)(dispatch, applyFilterType)(filteredOptions, noResultsFound);
  };

  _react["default"].useEffect(function () {
    if (!isOpen) {
      var id = window.requestAnimationFrame(function () {
        (0, _helpers.applyFilter)(dispatch, applyFilterType)([], false);
        setTextSearch("");
      });
      return function () {
        window.cancelAnimationFrame(id);
      };
    }
  }, [applyFilterType, dispatch, isOpen]);

  _react["default"].useEffect(function () {
    dispatch({
      type: _useListBox3["default"].types.hasFilter,
      payload: true
    });
  }, [dispatch]);

  if (isInline || isOpen) {
    var renderFilter = props.renderFilter,
        placeholder = props.placeholder,
        value = props.value,
        onChangeFilter = props.onChangeFilter,
        _filter = props.filter,
        hasSearchIcon = props.hasSearchIcon,
        noResultsMessage = props.noResultsMessage,
        moreProps = (0, _objectWithoutProperties2["default"])(props, _excluded);

    if (renderFilter) {
      return props.renderFilter(props);
    }

    return /*#__PURE__*/_react["default"].createElement(sc.Filter, {
      "data-pka-anchor": "list-filter"
    }, /*#__PURE__*/_react["default"].createElement(sc.FilterInput, (0, _extends2["default"])({
      a11yText: props.a11yText || I18n.t("listBox.filter.a11y_text"),
      "data-pka-anchor": "list-filter-input",
      icon: hasSearchIcon ? /*#__PURE__*/_react["default"].createElement(_Search["default"], null) : null,
      isDisabled: isDisabled,
      onChange: handleChangeFilter,
      onKeyDown: props.onKeyDown,
      placeholder: placeholder || I18n.t("listBox.filter.placeholder"),
      ref: refFilterInput,
      value: value || textSearch || "",
      size: size
    }, moreProps)));
  }

  return null;
});

var _default = Filter;
exports["default"] = _default;
Filter.displayName = "ListBox.Filter";
Filter.propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** Filters the list */
  filter: _propTypes["default"].func,

  /** If true displays a search icon */
  hasSearchIcon: _propTypes["default"].bool,

  /** Message displayed if no results are found */
  noResultsMessage: _propTypes["default"].string,

  /** Callback to be executed when the value is changed  */
  onChangeFilter: _propTypes["default"].func,

  /** Callback to be executed when a key is pressed */
  onKeyDown: _propTypes["default"].func,

  /** Displays a placeholder */
  placeholder: _propTypes["default"].string,

  /** Render function for filter */
  renderFilter: _propTypes["default"].func,

  /** Sets a value for filter */
  value: _propTypes["default"].string
};
Filter.defaultProps = {
  a11yText: null,
  filter: null,
  hasSearchIcon: true,
  onChangeFilter: null,
  onKeyDown: null,
  placeholder: null,
  noResultsMessage: null,
  renderFilter: null,
  value: null
};
//# sourceMappingURL=Filter.js.map